import { makePreloadSlot } from '../../../UnicronApp/preloader/PreloadSlot';
import { ExperimentCache } from '../types';

export const ExperimentSlot = makePreloadSlot('EXPERIMENT_CACHE', (): ExperimentCache => ({}));
